import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const CampaignContext = createContext(null);

export const CampaignProvider = ({ children }) => {
  const [campaign, setCampaign] = useState({ active: false, multiplier: 2, product_ids: [], name_ar: "", name_en: "" });

  useEffect(() => {
    api.get("/points-campaign").then(({ data }) => setCampaign(data)).catch(() => {});
  }, []);

  const inCampaign = (productId) => campaign.active && (campaign.product_ids || []).includes(productId);

  return (
    <CampaignContext.Provider value={{ campaign, inCampaign }}>
      {children}
    </CampaignContext.Provider>
  );
};

export const useCampaign = () => {
  const ctx = useContext(CampaignContext);
  if (!ctx) throw new Error("useCampaign must be inside CampaignProvider");
  return ctx;
};
